import { pickBy, omit } from 'lodash';

import {
  PAGINATION_LOAD_PAGE,
  PAGINATION_INVALIDATE_PAGES,
  PAGINATION_SET_ENTITIES,
  PAGINATION_SET_ENTITY_IDS,
  PAGINATION_CLEAR_COLLECTION,
} from '../actions/pagination';

export const INITIAL_STATE = {};

const withEntities = ({ state, entityIds, page, pageSize, entityCount, entityType }) => {
  const entityState = state[entityType] || {};
  const { entitiesByPage } = entityState;

  return {
    [entityType]: {
      ...entityState,
      entitiesByPage: {
        ...entitiesByPage,
        [page]: entityIds,
      },
      pageSize,
      entityCount,
    },
  };
};

const withEntityIds = ({ state, entityType, entityIds, entityCount }) => {
  const entityState = state[entityType];
  if (entityState) {
    const { entitiesByPage, currentPage } = entityState;

    return {
      [entityType]: {
        ...entityState,
        entitiesByPage: {
          ...entitiesByPage,
          [currentPage]: entityIds,
        },
        entityCount,
      },
    };
  }
};

const withCurrentPage = ({ state, entityType, currentPage }) => ({
  [entityType]: {
    ...state[entityType],
    currentPage: currentPage || 1,
  },
});

const withoutEntitiesByPage = ({ state, entityType, fromPage }) => {
  const entityState = state[entityType];
  if (entityState) {
    return {
      [entityType]: {
        ...entityState,
        entitiesByPage: fromPage ? pickBy(entityState.entitiesByPage, (_, page) => Number(page) < fromPage) : {},
      },
    };
  }
};

const paginationReducerNew = (state = INITIAL_STATE, { type, payload } = {}) => {
  switch (type) {
    case PAGINATION_CLEAR_COLLECTION:
      return omit(state, payload.entityType);
    case PAGINATION_LOAD_PAGE:
      return {
        ...state,
        ...withCurrentPage({ state, entityType: payload.entityType, currentPage: payload.page }),
      };
    case PAGINATION_SET_ENTITY_IDS: {
      const { entityType, entityIds, entityCount } = payload;
      return {
        ...state,
        ...withEntityIds({ state, entityType, entityIds, entityCount }),
      };
    }
    case PAGINATION_INVALIDATE_PAGES:
      return {
        ...state,
        ...withoutEntitiesByPage({ state, entityType: payload.entityType, fromPage: payload.fromPage }),
      };
    case PAGINATION_SET_ENTITIES: {
      const { entityType, entityIds, page, pageSize, entityCount } = payload;
      return {
        ...state,
        ...withEntities({ state, entityType, entityIds, page, pageSize, entityCount }),
      };
    }
    default:
      return state;
  }
};

export default paginationReducerNew;
